import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 



const styles = StyleSheet.create({
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },
        });


        
        
const Form15 = ({ result }) => {
  const gratuityAmount = Math.round(result.basicPay * result.calculation[0].gratuityFactor);
  const cappedGratuity = Math.min(2000000, gratuityAmount);
  
  const tableData = [
    ['1', 'Name (in block letters)', result.employeeName],
    ['2', 'Father’s Name (also husband’s name in the case of female Government Servant)', result.fatherName],
    ['3', 'Religion and Nationality', 'Indian'],
    ['4a', 'Permanent residence address showing Village/Town District and state (In Block letter)', result.address],
    ['4b', 'Address of residence where it is proposed to decide after retirement.', result.address],
    ['5', 'Present or last appointment including', result.designation],
    ['6',
         `Name of Establishment.
        Present or last substantive appointment
        Date of beginning of service.
        Date of ending service.`, 
    `${result.designation}
    ${result.managementName}
    ${result.dateOfAppointment}
    ${result.dateOfRetirement}`],

    ['7', 'Total period of Military Service', `${result.calculation[0].pensionableService.years} Years, ${result.calculation[0].pensionableService.months} Months, ${result.calculation[0].pensionableService.days} Days `],
    ['8', 'Date of ending Commitment and end of each period of Military Service.', 'Nil'],
    ['9', 'Amount and nature of any pension/gratuity received for Military Service.','Nil'],
    ['10', 'Government under which service has been rendered in order of employment', 'Nil'],
    ['11','Length of service with details, interruptions and non-qualifying periods.','Nil'],
    ['12','Class of pension or gratuity applied for, and Class of pension or gratuity applied for, and cause of application.',result.typeOfPension],
    ['13','Pensionable pay',result.basicPay],
    ['14','Proposed pension',result.pension],
    ['15','Proposed service gratuity/ Death-cum-retirement gratuity',cappedGratuity],
    ['16','Proposed family pension',result.pension],
  ];

  
  return (
              <View size="A4" style={style.page}> 
                <View style={[style.subtitle,]}>
                    <Text >
                    Pension Scheme for the Teaching staff in Non Government Secondary School
                    </Text> 
                    <Text style={[{marginTop: 0}]}>
                    ( vide G.R.E. & S.W.D.NO. SSN3365-G, dated 4th November 1968 )
                    </Text>
                </View>

                {/* <Text style={[style.title, style.ArialBlack]}>ANNEXURE I</Text> */}
                <Text style={[style.title, style.ArialBlack]}>FORM NO. 15</Text>
                <Text style={[style.subtitle, { fontSize: 8 }]}>(See rule 98, 198-A, 198-B, 207, 207-B 209 and 212)</Text>
                <Text style={[style.subtitle, { fontSize: 12 }]}>
                APPLICATION FOR PENSION OR GRATUITY (or DEATH CUM RETIREMENT GRATUITY)
                </Text>
            <View style={style.solidLine}/>
               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>
 

              </View>

);
};

export default Form15;